import { ControlValueAccessor } from '@angular/forms';

export abstract class AbstractControlValueAccessor implements ControlValueAccessor {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange = (_: any): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched = (): void => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public abstract writeValue(obj: any);

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      console.warn(`${this.constructor?.name}: setDisabledState not implemented`);
    }
  }
}
